import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  DateField,
  Resource,
  Show,
  Filter,
  Datagrid,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  EditButton,
} from "react-admin";

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput 
      label="Article category" 
      source="articleCategoryId" 
      reference="articleCategory" 
      alwaysOn
      filterToQuery={searchText => ({ name: searchText })}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const DefaultArticleManufacturingList = (props) => {
  return (
    <List {...props} filters={Filters(props)}>
      <div style={{ marginTop: '15px' }}>
        <Datagrid rowClick="show">
          <TextField source="id" />
          <ReferenceField 
            label="Article category" 
            source="articleCategoryId" 
            reference="articleCategory"
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField 
            label="Manufacturing" 
            source="manufacturingId" 
            reference="process/manufacturing"
          >
            <TextField source="name" />
          </ReferenceField>
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowDefaultArticleManufacturing = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="id" />
        <ReferenceField 
          label="Article category" 
          source="articleCategoryId" 
          reference="articleCategory"
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField 
          label="Manufacturing" 
          source="manufacturingId" 
          reference="process/manufacturing"
        >
          <TextField source="name" />
        </ReferenceField>
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateDefaultArticleManufacturing = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <ReferenceInput 
          label="Article category" 
          source="articleCategoryId" 
          reference="articleCategory"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput 
          label="Manufacturing" 
          source="manufacturingId" 
          reference="process/manufacturing"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};

const EditDefaultArticleManufacturing = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <ReferenceInput 
          label="Article category" 
          source="articleCategoryId" 
          reference="articleCategory"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput 
          label="Manufacturing" 
          source="manufacturingId" 
          reference="process/manufacturing"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  );
};

const defaultArticleManufacturingResource = () => (
  <Resource
    name="defaultArticleManufacturings"
    options={{ label: 'Default Article Manufacturing', menuGroup: 'Bcome' }}
    list={DefaultArticleManufacturingList}
    create={CreateDefaultArticleManufacturing}
    edit={EditDefaultArticleManufacturing}
    show={ShowDefaultArticleManufacturing}
  />
);

export default defaultArticleManufacturingResource;
